import { render, staticRenderFns } from "./WorkerShiftInfo.vue?vue&type=template&id=0a977a35&"
import script from "./WorkerShiftInfo.vue?vue&type=script&lang=js&"
export * from "./WorkerShiftInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports